// Separate from ./utils so scrollSlice stays clear of react-pdf, which breaks SSR.

export function getActivePage({topOffset, pagesWithDimensions}) {
    if (pagesWithDimensions.length === 0) {
        return undefined;
    }

    const match = pagesWithDimensions
        .find(({topBoundary, bottomBoundary}) => (
            topOffset >= Math.floor(topBoundary) && topOffset < bottomBoundary));

    if (match) {
        return match;
    }

    const lastPage = pagesWithDimensions[pagesWithDimensions.length - 1];
    if (topOffset >= lastPage.bottomBoundary) {
        return lastPage;
    }
    return pagesWithDimensions[0];
}

export function getActivePageId({topOffset, pagesWithDimensions}) {
    const activePageId = getActivePage({topOffset, pagesWithDimensions})?.pageId;
    return activePageId;
}
